import { signal } from '@preact/signals';
import type { ComponentChildren } from 'preact';

/** Cross-screen UI state: toasts, bottom sheets, dialogs, connectivity. */

export interface Toast {
  id: number;
  kind: 'success' | 'info' | 'undo';
  message: string;
  actionLabel?: string;
  onAction?: () => void;
  leaving?: boolean;
}

export const toasts = signal<Toast[]>([]);
let toastId = 0;

export function showToast(t: Omit<Toast, 'id'>, durationMs = 3200): number {
  const id = ++toastId;
  toasts.value = [...toasts.value, { ...t, id }];
  setTimeout(() => dismissToast(id), durationMs);
  return id;
}

export function dismissToast(id: number) {
  const t = toasts.value.find((x) => x.id === id);
  if (!t || t.leaving) return;
  toasts.value = toasts.value.map((x) => (x.id === id ? { ...x, leaving: true } : x));
  setTimeout(() => {
    toasts.value = toasts.value.filter((x) => x.id !== id);
  }, 200);
}

export interface SheetState {
  title?: string;
  content: ComponentChildren;
  leaving?: boolean;
}
export const sheet = signal<SheetState | null>(null);

export function openSheet(s: SheetState) {
  sheet.value = s;
}
export function closeSheet() {
  const s = sheet.value;
  if (!s || s.leaving) return;
  sheet.value = { ...s, leaving: true };
  setTimeout(() => (sheet.value = null), 200);
}

export interface DialogState {
  title: string;
  message: string;
  confirmLabel: string;
  danger?: boolean;
  onConfirm: () => void;
}
export const dialog = signal<DialogState | null>(null);

export const online = signal(navigator.onLine);
window.addEventListener('online', () => (online.value = true));
window.addEventListener('offline', () => (online.value = false));
